import { usePreview } from 'shared/domains/documents';
export const useCompanyLogo = () => {
    const { company, isFreeText, isComposed } = usePreview();
    const { logoPath, logoUploaded } = company || {};
    const available = Boolean(logoUploaded && logoPath && (isFreeText || isComposed));
    const height = '12.6mm';
    if (!available) {
        return {
            height,
            url: null,
        };
    }
    return {
        height,
        url: `${process.env.CDN_URL}/${logoPath}`,
    };
};
